import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import { CRMProvider, useCRM } from './context/CRMContext';
import Layout from './components/Layout/Layout';
import LoadingSpinner from './components/UI/LoadingSpinner';
import LoginForm from './components/Auth/LoginForm';

// Import all pages
import Dashboard from './pages/Dashboard';
import Leads from './pages/Leads';
import LeadSources from './pages/LeadSources';
import Clients from './pages/Clients';
import ClientProfile from './pages/ClientProfile';
import Contracts from './pages/Contracts';
import Services from './pages/Services';
import Works from './pages/Works';
import ChangeRequests from './pages/ChangeRequests';
import Renewals from './pages/Renewals';
import Tasks from './pages/Tasks';
import TaskReports from './pages/TaskReports';
import Users from './pages/Users';
import Roles from './pages/Roles';
import Departments from './pages/Departments';
import Settings from './pages/Settings';
import Notifications from './pages/Notifications';
import Profile from './pages/Profile';
import Payroll from './pages/Payroll';
import PrintPayslip from './pages/PrintPayslip';
import Messages from './pages/Messages';
import './index.css';

const AppContent = () => {
  const { user, loading: authLoading } = useAuth();
  const { loading: crmLoading } = useCRM();

  if (authLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <LoadingSpinner size="xl" />
          <p className="mt-4 text-gray-600">Checking authentication...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <LoginForm />;
  }

  if (crmLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <LoadingSpinner size="xl" />
          <p className="mt-4 text-gray-600">Loading your CRM data...</p>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Routes>
          {/* Print Route outside of Layout */}
          <Route path="/print-payslip/:id" element={<PrintPayslip />} />
          
          {/* Main App Routes */}
          <Route path="*" element={
            <Layout>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/messages" element={<Messages />} />
                <Route path="/leads" element={<Leads />} />
                <Route path="/lead-sources" element={<LeadSources />} />
                <Route path="/clients" element={<Clients />} />
                <Route path="/clients/:clientId" element={<ClientProfile />} />
                <Route path="/contracts" element={<Contracts />} />
                <Route path="/services" element={<Services />} />
                <Route path="/works" element={<Works />} />
                <Route path="/change-requests" element={<ChangeRequests />} />
                <Route path="/renewals" element={<Renewals />} />
                <Route path="/tasks" element={<Tasks />} />
                <Route path="/notifications" element={<Notifications />} />
                <Route path="/task-reports" element={<TaskReports />} />
                <Route path="/users" element={<Users />} />
                <Route path="/roles" element={<Roles />} />
                <Route path="/departments" element={<Departments />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/payroll" element={<Payroll />} />
              </Routes>
            </Layout>
          } />
        </Routes>
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
          }}
        />
      </div>
    </Router>
  );
};

function App() {
  return (
    <AuthProvider>
      <CRMProvider>
        <AppContent />
      </CRMProvider>
    </AuthProvider>
  );
}

export default App;